<div
  class="container"
  [class.reversed]="info.reversed"
>
  <div class="image-wrapper">
    <img
      class="image"
      [src]="info.imgSrc"
      imgErrLog
    />
  </div>
  <div class="text-wrapper">
    <div class="title">{{ info.title }}</div>
    <div class="blurb">{{ info.blurb }}</div>
  </div>
</div>
